import useHeldValue from 'hooks/useHeldValue'
import { EmptyArray, nonNullable } from 'lib/array/arrayUtils'
import { useMemo } from 'react'
import { MapLayerGroup } from 'tripPlanner/contexts/MapLayers/MapLayersContext'
import { PublicFullTrip, PublicTripItem } from 'tripPlanner/types/publicTrip'
import { TripItem } from 'tripPlanner/types/tripItem'
import { mapLEOfferToMarker } from '../utils'
import useExperiences from 'hooks/Experiences/useExperiences'
import { FullTrip } from 'tripPlanner/types/common'
import useExperienceSearchList from 'hooks/Experiences/useExperienceSearchList'

export default function useLEExperiencePins(
  trip: FullTrip | PublicFullTrip,
  layerGroups: Array<MapLayerGroup>,
  bounds: string | undefined,
) {
  const experiencesLayerEnabled = !!layerGroups.find(group => group.id === 'leProducts')?.layers.find(layer => layer.id === 'experiences')?.isSelected
  const shouldUseExperiences = experiencesLayerEnabled && !!bounds
  const { ids: _experienceIds = EmptyArray } = useExperienceSearchList({
    bounds,
    enabled: shouldUseExperiences,
  })
  const experienceIds = shouldUseExperiences ? _experienceIds : EmptyArray

  const [_experiences] = useExperiences(experienceIds)
  const experiences = useHeldValue(_experiences, experiencesLayerEnabled && _experiences.length === 0)

  const experiencesMarkers = useMemo(() => {
    const savedOfferIds = new Set(nonNullable(trip.items.map((item: TripItem | PublicTripItem) => 'code' in item ? item.code : undefined)))
    return experiences
      .filter(experience => !savedOfferIds.has(experience.id))
      .map(mapLEOfferToMarker)
  }, [experiences, trip.items])

  return experiencesMarkers
}
